import { Chip, type ChipProps } from "@mui/material";
import { type FC } from "react";

const STATUS_CONFIG: Record<
  string,
  { label: string; color: ChipProps["color"] }
> = {
  SUBMITTED: { label: "חדש", color: "info" },
  LOGGED_IN: { label: "התחבר", color: "secondary" },
  PROCESSED: { label: "טופל", color: "success" },
  PARTIALLY_PROCESSED: { label: "טופל חלקית", color: "warning" },
  DECLINED: { label: "לא לטפל", color: "default" },
};

export const LeadStatusChip: FC<{ status: string }> = ({ status }) => {
  const config = STATUS_CONFIG[status] ?? { label: status, color: "default" as const };
  return (
    <Chip
      size="small"
      label={config.label}
      color={config.color}
      variant="outlined"
      sx={{ fontWeight: 500 }}
    />
  );
};
